import React, {Fragment} from 'react';
import { Grid } from '@material-ui/core';
import _ from 'lodash'
import styled from 'styled-components';
import { connect as reduxConnect } from "react-redux";
import { connect } from 'formik';
import { compose} from "redux";
import moment from 'moment';
import { AutoCompleteInput } from 'components/Global/FormikMaterial';
import { prepaymentTypes } from "../Constants/DropDownLists";
import { FLAT_PERCENTAGE,
  SPREAD_MAINTENANCE,
  MAKE_WHOLE,
  DEFEASANCE,
  YIELD_MAINTENANCE_TRADITIONAL,
  YIELD_MAINTENANCE_AGENCY_STYLE,
  AGGREGATE_INTEREST } from '../Constants/PrepaymentType';
import { getYieldTestData} from "store/state/calculators/testHarness";
import {TREASURIES} from '../Constants/Constants';
import {
  FlatPercentageFields, 
  SpreadMaintenanceFields,
  MakeWholeFields, 
  DefeasanceFields, 
  YieldMaintenanceTraditionalFields, 
  YieldMaintenanceAgencyStyleFields,
  AggregateInterestFields} from './PrepaymentFormVariants';
import FormSectionTitle from './FormSectionTitle';

const StyledAutoCompleteInput = styled(AutoCompleteInput)`
  & {width:100%;}
`
const StyledLabel = styled.div`{
  //styleName: Work Sans / 16 Medium;
  font-family: Work Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
 }`;
const getCalculationDate = (loanStartDate, prepaymentDate) => {
  let loanStartDayOfMonth = loanStartDate.date();
  if(prepaymentDate.date() <= loanStartDayOfMonth)
    return prepaymentDate.date(loanStartDayOfMonth);  
  return prepaymentDate.add(1, 'months').date(loanStartDate.date());  
}

const getPeriodsRemainingUntilOpen = (startDate, term, openPeriods, prepaymentDate) => {
  let momentStartDate = moment(startDate).startOf('day');  
  let momentPrepaymentDate = moment(prepaymentDate).startOf('day');
  const calculationDate = getCalculationDate(momentStartDate, momentPrepaymentDate)  
  return (term - +openPeriods) - calculationDate.diff(momentStartDate, 'months')
}

class PrepaymentFormSection extends React.Component {
  state ={
    periodsRemainingUntilOpen: 0
  }

  componentDidMount(){
    const { updatePeriodsRemainingUntilOpen } = this.props;
    const { startDate, prepaymentDate, loanTerm, openPeriods } = this.props.formik.values;
    
    let periodsRemainingUntilOpen = getPeriodsRemainingUntilOpen(startDate, loanTerm, openPeriods, prepaymentDate);
    updatePeriodsRemainingUntilOpen(periodsRemainingUntilOpen);
    this.props.getYieldTestData({ curve: TREASURIES, tenorValue: periodsRemainingUntilOpen /12 });
    this.setState({periodsRemainingUntilOpen})
  }
  
  componentDidUpdate(prevProps) {
    const { updatePeriodsRemainingUntilOpen } = this.props;
    const { startDate, prepaymentDate, loanTerm, openPeriods } = this.props.formik.values;
    const { startDate : prevStartDate, prepaymentDate: prevPrepaymentDate, loanTerm: prevLoanTerm, openPeriods: prevOpenPeriods, } = prevProps.formik.values;

    if(startDate !== prevStartDate || prepaymentDate !== prevPrepaymentDate || loanTerm !== prevLoanTerm || openPeriods !== prevOpenPeriods) {
      
      let periodsRemainingUntilOpen = getPeriodsRemainingUntilOpen(startDate, loanTerm, openPeriods, prepaymentDate);
      updatePeriodsRemainingUntilOpen(periodsRemainingUntilOpen);
      this.props.getYieldTestData({curve: TREASURIES, tenorValue: periodsRemainingUntilOpen /12});
      this.setState({periodsRemainingUntilOpen})
    }
  }

  render(){    
    const {formik, yieldCurveResult} = this.props;
    const {periodsRemainingUntilOpen} = this.state;
    const {
      prepaymentType,
      interestRate, 
      aggregateInterestMethod
    } = formik.values;
    
    return (
      <Fragment>
        <Grid item xs={8}>
          <FormSectionTitle title="Prepayment Information"/>
        </Grid>
        <Grid container item xs={12} spacing={8}>
          <Grid item xs={6}>
            <StyledAutoCompleteInput 
              id="dropdownForPrepaymentType"
              label={<StyledLabel>{"Prepayment Type"}</StyledLabel>}              
              fieldName="prepaymentType"
              selectValue="value"
              options={prepaymentTypes}
              formik={formik}/>
          </Grid>
          { prepaymentType === YIELD_MAINTENANCE_TRADITIONAL && 
            <YieldMaintenanceTraditionalFields periodsRemainingUntilOpen={periodsRemainingUntilOpen} replacementRate={yieldCurveResult} rate={interestRate}/> 
          }
          
          { prepaymentType === YIELD_MAINTENANCE_AGENCY_STYLE && 
            <YieldMaintenanceAgencyStyleFields periodsRemainingUntilOpen={periodsRemainingUntilOpen} replacementRate={yieldCurveResult} rate={interestRate}/> 
          }
          
          { prepaymentType === DEFEASANCE && 
            <DefeasanceFields periodsRemainingUntilOpen={periodsRemainingUntilOpen}/> 
          }
          
          { prepaymentType === MAKE_WHOLE && 
            <MakeWholeFields periodsRemainingUntilOpen={periodsRemainingUntilOpen}/> 
          }
          
          { prepaymentType === SPREAD_MAINTENANCE && 
            <SpreadMaintenanceFields periodsRemainingUntilOpen={periodsRemainingUntilOpen}/> 
          }
          
          { prepaymentType === AGGREGATE_INTEREST && 
            <AggregateInterestFields aggregateInterestMethod={aggregateInterestMethod}/> 
          }
          
          { prepaymentType === FLAT_PERCENTAGE && 
            <FlatPercentageFields/> 
          }
        </Grid>
      </Fragment>
  )};
}

const mapStateToProps = ({ testHarness }) => ({
  yieldCurveResult: _.get(testHarness, 'testData.yieldCurveResult', 0)
});

export default compose(  
  connect,
  reduxConnect(
    mapStateToProps,
    {
      getYieldTestData
    }
  )
)(PrepaymentFormSection);